import { createStyles, withStyles, WithStyles } from "@mui/styles";
import Toolbar, { ToolbarProps } from "@mui/material/Toolbar";
import classNames from "classnames";
import * as React from "react";


const style = createStyles({
    filterToolbarContainer: {
        flexDirection: "column",
        alignItems: "initial",
        justifyContent: "space-around",
    },
});

interface IProps {
}

type props = IProps & ToolbarProps & WithStyles<typeof style>;

class MuiFilterToolbar extends React.Component<props> {
    public render() {
        const { className, classes, children, disableGutters, ...rest } = this.props;

        const cardClasses = classNames({
            [classes.filterToolbarContainer]: true,
            [className]: className !== undefined
        });

        return <Toolbar className={cardClasses} disableGutters={disableGutters || true} {...rest}>{children}</Toolbar>;
    }
}


export default withStyles(style)(MuiFilterToolbar);
